import { Link } from 'react-router-dom';

import { useLanguage } from '../context/LanguageContext';
import { residences } from '../data/residences';
import PropertyVisual from './PropertyVisual';

function ResidenceGrid({ limit }) {
  const { language, t } = useLanguage();
  const items = typeof limit === 'number' ? residences.slice(0, limit) : residences;

  return (
    <div className="residence-grid">
      {items.map((residence) => (
        <article className="residence-card" key={residence.id}>
          <Link to={`/residences/${residence.id}`} className="residence-card__visual" aria-label={residence.name[language]}>
            <PropertyVisual src={residence.image} alt={residence.name[language]} />
          </Link>
          <div className="residence-card__content">
            <div>
              <span className="eyebrow">{residence.category[language]}</span>
              <h3>{residence.name[language]}</h3>
            </div>
            <Link className="text-link" to={`/residences/${residence.id}`}>{t('common.learnMore')} <span>↗</span></Link>
          </div>
        </article>
      ))}
    </div>
  );
}

export default ResidenceGrid;
